/* eslint-disable */

import { Col, Row } from "react-bootstrap";
import { useReport } from "../ReportContext";
import SectionIntroduction from "../components/SectionIntroduction";
import NextPrevLinks from "../../components/NextPrevLinks";

const PositiveNegative = () => {
	const { reportContent: { acf: { positive_negative } } } = useReport();
	return (
		<div className="report-view">
			<SectionIntroduction text={positive_negative.introduction} />

			<hr />

			<Row>
				<Col>
					<h2>You Reported a <span className="text-rating" style={{color: "var(--bs-danger)"}}>"Quite Low"</span> Positive-Negative Balance</h2>
					<p>Rating-specific content here...</p>
				</Col>
				<Col>
					Chart Here
				</Col>
			</Row>

			<hr />
			
			<NextPrevLinks />
		</div>
	);
};

export default PositiveNegative;
